import React from "react";
import useAddTripPlanning from "./useAddTripPlanning.hooks";
import Breadcumbs from "../../../../../component/page-components/breadcumbs/breadcumbs";
import HeaderPages from "../../../../../component/page-components/pages-header";
import PrimaryButton from "../../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../../component/button/SecondaryButton";
import { Input, Skeleton } from "antd";
import MapsSingle from "../../../../../component/maps/MapsSingle";
import TabOrderAdd from "./tab-order/tab-order-add";
import TabTransporter from "./tab-transporter/tab-transporter";
import MapsMultipleMarker from "../../../../../component/maps/MapsMultipleMarker";
import ModalViewDetailAddListOrder from "../../../../../component/modal/ModalViewDetailAddListOrder";
import ModalViewDetailAddListDA from "../../../../../component/modal/ModalViewDetailAddListDA";
import NotifAddSuccess from "../../../../../component/modal/NotifAddSuccess";
import NotifFailedSaved from "../../../../../component/modal/NotifFailedSaved";
import PopUpMaxOrderSelected from "./PopUpMaxOrderSelected";
import ModalPhoto from "../../../../../component/modal/ModalPhoto";

const MainAddTripPlanning = () => {
  const {
    depotLat,
    depotLong,
    isLoading,
    listOrder,
    orderSelected,
    jmlOrderTerpilih,
    tab,
    isCheckedAll,
    listDA,
    modalViewDetailOrder,
    dataViewDetailOrder,
    tripPlanName,
    modalViewDetailDA,
    dataViewDetailDA,
    errorTripPlanName,
    isModalSuccessAdd,
    isModalFailed,
    messageFailed,
    processSelectAll,
    searchRecommendation,
    jmlDataOrder,
    modalPopUpMaxOrderSelected,
    isViewDetailPhoto,
    photoPath,
    onSearchListOrder,
    setIsModalFailed,
    handleOKSuccess,
    checkIsExist,
    backToList,
    viewDetailListOrder,
    checkBoxListOrder,
    handleNext,
    handleBack,
    handleCheckSelectAll,
    closeModalDetailOrder,
    onChangePlanName,
    onSubmit,
    checkBoxListDA,
    viewDetailDA,
    closeModalViewDetailDA,
    checkIsExistListDA,
    onSelectSearchRecommendation,
    setModalPopUpMaxOrderSelected,
    onPreviewPhoto,
    onClosePreviewPhoto,
  } = useAddTripPlanning();

  return (
    <div>
      <Breadcumbs
        jmlLevel={4}
        menuLevel1="Order"
        menuLevel2="Routes"
        menuLevel3="Trip Planning"
        menuLevel4="Add Trip Planning"
      />
      <HeaderPages
        menuType="add"
        title="Add Trip Planning"
        handleBack={backToList}
      />
      {/* Container with bg-white */}
      <div className="w-full bg-white-100 p-[24px] border-2 border-gray-700 rounded-lg min-h-[900px]">
        {/* Tab */}
        <div className="h-[52px] w-[391px] bg-gray-700 p-2 rounded-lg grid grid-cols-2 items-center justify-center">
          <div className="flex flex-row">
            <div className="basis-1/4">
              <div
                className={`flex justify-center items-center w-[36px] h-[36px] rounded-[18px] `.concat(
                  tab === 1 ? "bg-red-100" : " bg-green-100"
                )}
              >
                <p className="font-sans font-semibold text-white-100 text-xl">
                  {" "}
                  1{" "}
                </p>
              </div>
            </div>
            <div
              className={`basis-1/4 font-sans font-bold text-xl flex justify-center items-center `.concat(
                tab === 1 ? "text-red-100" : "text-green-100"
              )}
            >
              {" "}
              Order{" "}
            </div>
            <div className="basis-1/2 flex justify-center items-center px-3">
              <hr
                className={`border-2 solid w-full `.concat(
                  tab === 1
                    ? "border-gray-500 border-dashed"
                    : "border-green-100 border-solid"
                )}
              />
            </div>
          </div>
          <div className="flex flex-row">
            <div className="basis-1/4">
              <div
                className={`flex justify-center items-center w-[36px] h-[36px] rounded-[18px] drop-shadow-2xl `.concat(
                  tab === 1 ? "bg-white-100" : "bg-red-100"
                )}
              >
                <p
                  className={`font-sans font-semibold text-xl `.concat(
                    tab === 1 ? "text-gray-600" : "text-white-100"
                  )}
                >
                  {" "}
                  2{" "}
                </p>
              </div>
            </div>
            <div
              className={`basis-1/2 font-sans font-bold text-xl flex justify-center items-center `.concat(
                tab === 1 ? "text-gray-100" : "text-red-100"
              )}
            >
              {" "}
              Transporter{" "}
            </div>
          </div>
        </div>

        {/* Content Tab */}
        <div id="content" className="flex flex-col mt-5">
          {/* Sub Title Content */}
          <h3 className="font-roboto text-[18px] font-semibold mb-5">
            Order Detail
          </h3>

          {/* Input Data */}
          <div className="flex flex-row gap-60 mb-6">
            <div className="flex flex-col w-[500px]">
              <h3 className="font-roboto text-[18px] font-semibold mb-2">
                Trip Plan ID
              </h3>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Autogenerated"
                disabled
              />
            </div>
            <div className="flex flex-col w-[500px]">
              <h3 className="font-roboto text-[18px] font-semibold mb-2">
                Plan Name
              </h3>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Plan Name"
                onChange={(evt) => {
                  onChangePlanName(evt);
                }}
                value={tripPlanName}
                status={errorTripPlanName ? "error" : null}
              />
              {errorTripPlanName ? (
                <div className="text-red-100">{errorTripPlanName}</div>
              ) : null}
            </div>
          </div>

          {/* Maps */}
          {isLoading ? (
            <Skeleton />
          ) : (
            <div className="rounded-md h-[400px]">
              {tab === 1 ? (
                <MapsSingle trip lat={depotLat} long={depotLong} />
              ) : (
                <>
                  <MapsMultipleMarker
                    lat={depotLat}
                    long={depotLong}
                    listLatLng={orderSelected}
                  />
                </>
              )}
            </div>
          )}

          {/* Content Tab */}
          {tab === 1 ? (
            <TabOrderAdd
              listOrder={listOrder}
              checkBoxListOrder={checkBoxListOrder}
              orderSelected={orderSelected}
              viewDetailListOrder={viewDetailListOrder}
              jmlOrderTerpilih={jmlOrderTerpilih}
              handleCheckSelectAll={handleCheckSelectAll}
              checkIsExist={checkIsExist}
              isCheckedAll={isCheckedAll}
              processSelectAll={processSelectAll}
              searchListOrder={onSearchListOrder}
              search={searchRecommendation}
              jmlDataOrder={jmlDataOrder}
              selectListOrder={onSelectSearchRecommendation}
            />
          ) : (
            <TabTransporter
              listDA={listDA}
              checkBoxListDA={checkBoxListDA}
              viewDetailDA={viewDetailDA}
              checkIsExistListDA={checkIsExistListDA}
            />
          )}
        </div>
      </div>

      {/* Footer */}
      {tab === 1 ? (
        <div className="w-full h-full flex flex-row justify-end items-end gap-4 mt-10">
          <SecondaryButton text="Cancel" />
          <PrimaryButton text="Next" action={handleNext} />
        </div>
      ) : (
        <div className="w-full h-full flex flex-row justify-end items-end gap-4 mt-10">
          <SecondaryButton text="Previous" action={handleBack} />
          <PrimaryButton text="Add" action={onSubmit} />
        </div>
      )}
      <ModalViewDetailAddListOrder
        isModalOpen={modalViewDetailOrder}
        close={closeModalDetailOrder}
        data={dataViewDetailOrder}
        onPreviewImg={(evt) => {
          onPreviewPhoto(evt);
        }}
      />
      <ModalViewDetailAddListDA
        isModalOpen={modalViewDetailDA}
        close={closeModalViewDetailDA}
        data={dataViewDetailDA}
      />
      <NotifAddSuccess
        menu="Trip Planning"
        visible={isModalSuccessAdd}
        action={handleOKSuccess}
      />
      <NotifFailedSaved
        visible={isModalFailed}
        message={messageFailed}
        action={() => {
          setIsModalFailed(false);
        }}
      />
      <PopUpMaxOrderSelected
        modalPopUpMaxOrderSelected={modalPopUpMaxOrderSelected}
        close={() => {
          setModalPopUpMaxOrderSelected(false);
        }}
      />
      <ModalPhoto
        photo={photoPath}
        show={isViewDetailPhoto}
        img={photoPath}
        onClose={onClosePreviewPhoto}
      />
    </div>
  );
};

export default MainAddTripPlanning;
